import { render, staticRenderFns } from "./ParcelReportSettings.vue?vue&type=template&id=389bc5dc&"
import script from "./ParcelReportSettings.vue?vue&type=script&lang=js&"
export * from "./ParcelReportSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports